<template>
    <div class="doby">
      <div class="header">
        <img class="img col-xs-1" src="../../assets/img/logo_blanco[27].png" />
      </div>
      <div class="row mb-3">
        <div class="col-1"></div>
        <div class="col-10">
          <div v-if="!tramiteEnviado" class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-6">
                  <h4 class="card-title">Carga de documentación</h4>
                </div>
      
                <div class="form-group col-6 tablet-sm-6">
                  <h5 class="card-title float-right ">Folio: {{folio}}</h5>
                </div>
      
                <div class="col-12">
                  <p class="card-title titulo5">
                    Para continuar con el tramite, por favor firma la siguiente documentación y subirla al sistema:
                  </p>
                  <div class="table-responsive col-12-md">
                    <table class="table">
                      <thead>
                        <tr class="table-blue">
                          <th class="columna" scope="col">Documento</th>
                          <th class="columnaCargar" scope="col">Cargar Archivo</th>
                          <th class="columnaBtn"></th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(file, h) in listArchivos" :key="h">
                            <td>{{ file.Txt_requisito }}</td>
                            <td>
                                <button v-if="file.UrlFormulario && file.ACEPTADO === 'NO'" @click="redireccionformulario(file)"  type="button" class="btn btn-info btn-sm mr-1 mb-1" >
                                Llenar Formato
                                </button>
                                <button
                                @click="descargarFormato(file)" v-if="file.SNArchivo == 'S' "
                                 :disabled="file.UrlFormulario && file.ACEPTADO === 'NO' ?  true :  false"  type="button" class=" btn-sm btn btn-warning mr-1 mb-1" >
                                Descargar Formato
                                </button>
                            </td>
                            <td>
                                <input type="file" :disabled="file.SNArchivo === 'S' && file.NombreCampo === null" class="file-select" @change="onChangeFile($event, file)"/>
                                <button :disabled="file.SNArchivo == 'S' && file.NombreCampo === null"  @click="cargar(file)" type="button" class="btn btn-sm btn-success mr-2 mb-1 mt-1" >
                                    Cargar
                                </button>
                                <button :disabled="file.TipoCampo === null" @click="eliminar(file)" type="button" class="btn btn-sm btn-danger mb-1 mt-1" >
                                    Eliminar
                                </button>
                            </td>
                            <td>
                              <button @click=" mostrarPDF(file.Valor)" v-if="file.TipoCampo !== null" class="btn btn-link ml-3" >
                            <img class="imgpdf col-xs-1" src="../../assets/img/pdf.png" />
                          </button>
                          <!-- <label id="lblacta" for="">{{ file.Archivo }}</label> -->
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
               <button class="btn btn-primary--custom m-4 float-right" @click="sendTramite()">Enviar</button>
              <CModal color="" :show.sync="modals.pdfModal" :close-on-backdrop="false">
                <template #footer-wrapper><span></span></template>
                <div class="card-body p-0">
                  <iframe class="iframePdf" :src="pdf" frameborder="0"></iframe>
                </div>
                <CCardFooter align="right" class="pt-3 pl-0 pr-0 pb-0">
                  <CButton @click="modals.pdfModal = false" color="outline-secondary"
                    >Cerrar
                  </CButton>
                </CCardFooter>
              </CModal>
            </div>
          </div>
          
          <div v-if="tramiteEnviado" class="card" >
            <div class="card-body text-center">
              <div class="col-12 mt-4 mb-4">
                <h1 class="text-center text-succes">
                  <svg  xmlns="http://www.w3.org/2000/svg" width="160" height="100" fill="currentColor" class="bi bi-check-circle" viewBox="0 0 16 16">
                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                    <path d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z"/>
                  </svg>
                </h1>
                  <h3 class="card-title text-center mt-4">Documentos enviados exitosamente</h3>
              </div>
            </div>
          </div>
        </div>
        <div class="col-2"></div>
      </div>
      <loading v-if="load"></loading>
    </div>
  </template>
  
  <script>
import Loading from '../../componentes/ImgLoading/loading.vue';

  export default {
    components: {Loading},
    data() {
      return {
        listArchivos: [],
        listAlmacenados: [],
        listArchiPDF: [],
        load: true,
        folio: "",
        URLFormulario: "",
        convertPDF: "",
        tipoArchivo: "",
        extenArchivo: "",
        nombreArchivo: "",
        Archivo:"",
        pdf: "",
        idProceso: "",
        idEstatusRechaza: "",
        idEstatusAcepta: "",
        token: this.$route.params.token,
        llenarformato: true,
        respDescargar: true,
        tramiteEnviado: false,
        modals: { pdfModal: false },
      };
    },
    methods: {
      async ValidarToken() {
        this.load = false;
        var config = {
          metodo: "VALIDATOKENRUTA",
          data: `sToken=${this.token}`,
        };
        this.$store.dispatch("metodoPost", config).then(() => {
          const res = this.$store.getters.getRespuestaREST;
          if (res.flag) {
            this.idCtrlSolicitud = res.data.idCtrlSolicitud;
            this.folio = res.data.Folio;
            this.idEstatusAcepta = res.data.idEstatusAcepta
            this.idEstatusRechaza = res.data.idEstatusRechaza
            this.idProceso = res.data.idProceso
            this.Requisitos();
          } else {
            window.location.href = `${location.origin}/#/pages/app/errorToken`;
          }
        });
      },
      async Requisitos() {
        this.load = true;
        const payload = {
          metodo: "OBTENERDOCUMENTOSCONTRATACION",
          data: {
            idCtrlSolicitud: this.idCtrlSolicitud,
            Folio: this.folio,
          },
        };
        try {
          const response = await this.$store.dispatch("metodoPost", payload);
          if (response) {
            const res = this.$store.getters.getRespuestaREST;
            this.listArchivos = res;
            
          }
        } catch (error) {
          console.log(error);
        }
      },
      redireccionformulario(file) {
        // se hace for para encrontrar el objeto en el arreglo pricipal
        for (let i = 0; i < this.listArchivos.length; i++) {
          if(file.idDocumento == this.listArchivos[i].idDocumento){

            this.listArchivos[i].ACEPTADO = 'SI';
          }
        }
        window.open(file.UrlFormulario, '_blank');
      },
      async descargarFormato(file) {
        this.load = true;
        const payload = {
          metodo: "OBTENERDOCUMENTOPDF",
          data: {
            idCtrlSolicitud: this.idCtrlSolicitud,
            Folio: this.folio,
            // sTokenFormulario: "df142f3b-6cea-4e65-85e3-1d256d7278e8",
            // sIdDocumento:"85"
            sTokenFormulario: file.tokenFormulario,
            sIdDocumento:file.idDocumento
          },
        };
        try {
          const response = await this.$store.dispatch("metodoPost", payload);
          this.respDescargar = response;
          if (response) {
            const res = this.$store.getters.getRespuestaREST;
            var bin = atob(res);
            this.convertPDF = 'data:application/pdf;base64,' + res;
            var down = document.createElement('a');
            down.href = this.convertPDF;
            down.target = '_blank';
            down.download = file.Txt_requisito
            document.body.appendChild(down);
            down.click();
            document.body.removeChild(down)
            
            // BUSCARG REGISTRO Y LE CAMBIAS PROPIEDAD 
            for (let i = 0; i < this.listArchivos.length; i++) {
              if(file.idDocumento == this.listArchivos[i].idDocumento){
                this.listArchivos[i].Opciones = 'H';
                this.listArchivos[i].NombreCampo = 'N';
              } 
            }
          } else {
            // BUSCARG REGISTRO Y LE CAMBIAS PROPIEDAD ACEPTADO A NO 
            for (let i = 0; i < this.listArchivos.length; i++) {
              if(file.idDocumento == this.listArchivos[i].idDocumento){

                this.listArchivos[i].ACEPTADO = 'NO';
              }
            }
                
            this.$swal({
              icon: "warning",
              title: "Error al descargar formato.",
              showConfirmButton: true
            });
          }
        } catch (error) {
          console.log(error);
        }
      },
      onChangeFile(event, file) {
        for (let i = 0; i < this.listArchivos.length; i++) {
          if(file.idDocumento == this.listArchivos[i].idDocumento){

              // this.listArchivos[i].SNArchivo = 'P';
            }
        }

        this.nombreArchivo = event.target.files[0].name;
        this.tipoArchivo = event.target.files[0].type;
        this.extenArchivo = "." + event.target.files[0].name.split(".").pop();
        this.Archivo = event.target.files[0];
        this.listArchiPDF.push(this.Archivo)
      },
      convertBase64(blob) {
      return new Promise((resolve, reject) => {
        var reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onloadend = () => {
          resolve(reader.result.split(",")[1]);
        };
      });
      },
      async cargar(file) {
      if (this.tipoArchivo !== "application/pdf") {
        // alerta de rror
        this.$swal({
          icon: "warning",
          title: "Archivo invalido",
          text: "Solo cargar archivos PDF",
          showConfirmButton: false,
          timer: 2200,
        });
        return;
      }
        this.archivoBase64 = await this.convertBase64(this.Archivo);
        await this.realizapeti(file);
        for (let i = 0; i < this.listArchivos.length; i++) {
          if(file.idDocumento == this.listArchivos[i].idDocumento){

              this.listArchivos[i].TipoCampo = '1';
              // this.listArchivos[i].SNArchivo = 'S';
              // this.listArchivos[i].Archivo = this.Archivo;
            }
        }
      },
      eliminar(file) {
        // pregunta si esta seguro eliminar
        this.$swal({
          title: "Estas seguro?",
          text: "No podrás revertir esta acción!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Borrar",
        }).then((result) => {
          if (result.isConfirmed) {
            let arrTemp = this.listAlmacenados;

            for (let i = 0; i < arrTemp.length; i++) {
              if (file.ID_Requisito === arrTemp[i].ID_Requisito) {
                this.listAlmacenados[i] = null;
              }
            }

            this.listAlmacenados = this.listAlmacenados.filter(Boolean);


            for (let i = 0; i < this.listArchivos.length; i++) {
            if(file.idDocumento == this.listArchivos[i].idDocumento){
                this.listArchivos[i].Id_Archivo = "0";
                this.listArchivos[i].Archivo = '';
              }
            }

            this.nombreArchivo = "";
            this.tipoArchivo = "";
            this.extenArchivo = "";
            this.Archivo = null;
            this.listMulti = [];
            this.listAlmacenados = [];

            this.$swal(
              "Eliminado!",
              "" + file.Archivo + "Archivo eliminado correctamente",
              "success"
            );
          }
        });
      },
      async realizapeti(file) {
        this.loading = true;
        const payload = {
          metodo: "GUARDARARCHIVOSCONTRATACION",
          data: {
            base64: this.archivoBase64,
            nombre: this.nombreArchivo,
            contentType: this.tipoArchivo,
            extension: this.extenArchivo,
          },
        };
        console.log(payload);
        console.log(this.archivoBase64);
        try {
          const response = await this.$store.dispatch("metodoPost", payload);
          if (response) {
            const res = this.$store.getters.getRespuestaREST;
            console.log(this.$store.getters);
            const itemFile = {
              nombre: this.nombreArchivo,
              contentType: this.tipoArchivo,
              extension: this.extenArchivo,
              idArchivo: res,
              ID_Requisito: file.ID_Requisito,
              IDCatRequisito: file.IDCatRequisito,
            };

            this.listAlmacenados.push(itemFile);
            
            for (let i = 0; i < this.listArchivos.length; i++) {
            if(file.idDocumento == this.listArchivos[i].idDocumento){
              this.listArchivos[i].Valor = this.archivoBase64;
              }
            }

            // alert de cargado con exito
            this.loading = false;
            this.$swal({
              icon: "success",
              title: "Archivo cargado",
              text:
                "El archivo " + this.nombreArchivo + " se cargo exitosamente.",
              showConfirmButton: true,
            });
          } else {
            this.$swal({
              icon: "error",
              title: "Error",
              text:
                "El archivo " +
                this.nombreArchivo +
                " no se pudo cargar, intentalo más tarde.",
              showConfirmButton: true,
            });
          }
        } catch (error) {}
      },
      async sendTramite() {
        const payload = {
          metodo: "SETTRAMITEVILLREQ",
          data: {
            idCtrlSolicitud: this.idCtrlSolicitud,
            Folio: this.folio,
            idCatAccion: "2",
            idEstatusAcepta: this.idEstatusAcepta,
            idEstatusRechaza: this.idEstatusRechaza,
            idProceso: this.idProceso,
            sComentarios: "SE ENVIAN DOCUMENTOS.",
            lstArchivos: this.listAlmacenados,
          },
        };
        try {
          const response = await this.$store.dispatch("metodoPost", payload);
          if (response) {
            const res = this.$store.getters.getRespuestaREST;
            this.$swal({
              icon: "success",
              title: "Correcto",
              text:
                "Hemos recibido tu documentación, en breve serás contactado por La Latino Seguros, Gracias.",
              showConfirmButton: true,
            });
            this.tramiteEnviado = true;
            this.listAlmacenados = [];
            this.listMulti = [];
            this.nombreArchivo = "";
            this.tipoArchivo = "";
            this.extenArchivo = "";
            this.Archivo = null;
            // window.close();
          } else {
            this.$swal({
              icon: "error",
              title: "Error",
              text: "Ocurrio un error intenta mas tarde.",
              showConfirmButton: true,
            }).then((result) => {
              // var customWindow = window.open('', '_blank', '');
              // customWindow.close();
              // // var abrir = window.open(window.location.href)
              // // window.location.href = "https://www.google.com/";
            })
          }
        } 
        catch (error) {
          console.log(error);
        }
      },
      async mostrarPDF(base64) {
      this.modals.pdfModal = true
      var bin = atob(base64);
      this.pdf = 'data:application/pdf;base64,' + base64;
      },
    },
    mounted() {
      // const promise = new Promise((resolve, _) => {
      //     resolve(
            this.ValidarToken()
    //         );
    //     });
    //     promise.then(_ => {
    //       setTimeout(() => {
    //         this.Requisitos();
    //       }, 1500)
    //     }
    //   );
    },
   };
  </script>
  
  
  <style>
  .iframePdf {
    width: 480px;
    height: 300px;
  }
  .header {
    background-color: #003873;
    height: 150px;
  }
  .img {
    height: 120px;
    margin-left: 25px;
    margin-top: 15px;
  }
  .card {
    /* width: 50rem; */
    height: 95%;
    margin: 30px;
    border-radius: 25px;
  }
  .titulo5 {
    color: gray;
  }
  .parrafo {
    font-size: 12px;
    color: gray;
  }
  .imgpdf {
    height: 35px;
  }
  .table-blue {
    background-color: #003873;
    color: white;
  }
  /* table{
    table-layout: fixed;
  } */
  @media screen and (min-width: 321px) and (max-width: 1280px) { 
    .columna {
    width: 300px;
    overflow: auto;
  }
  .columnaCargar {
    width: 280px;
    overflow: auto;
  }
  }
  
  /* .columnaBtn {
    width: 370px;
    overflow: auto;
  } */
  
  .file-select {
    position: relative;
    display: inline-block;
    width: 140px;
    height: 30px;
    margin-right: 20px;
  }
  
  .file-select::before {
    background-color: #e2e1e1;
    color: rgb(153, 152, 152);
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 3px;
    font-size: small;
    content: "Seleccionar archivo";
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
  }
  </style>